export default (theme) => ({
  container: {
    padding: 20,
  },
});
